import { render, staticRenderFns } from "./submitInfoPage.vue?vue&type=template&id=5f80f717"
import script from "./submitInfoPage.vue?vue&type=script&lang=js"
export * from "./submitInfoPage.vue?vue&type=script&lang=js"
import style0 from "./submitInfoPage.vue?vue&type=style&index=0&id=5f80f717&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports